import { constants } from '../../constants';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        ...constants.layout.sectionTopBottomMargins,
        ...constants.layout.contentWidth,
        maxWidth: constants.layout.contentWidth.maxWidth - 20, /* -20px override to allow for card margins */
        // marginBottom: constants.layout.contentWidth.marginBottom, /* Adding this allows us to override marginBottom for lone titles */
    },
    outerContainer: {
        backgroundColor: 'transparent',
        display:'flex',
        justifyContent: 'space-around',
    },
    subSection: {
        display: 'flex',
        flex: '1 1 30%',
        justifyContent: 'flex-start',
        marginLeft: 10,
        marginRight: 10,
        minWidth: 300,
    },
}

export { styles as fluidSectionsStyles };


// WEBPACK FOOTER //
// ./src/js/components/FluidSection/styles.ts